<template>
<el-container class="ResourceManageContainer">
  <el-aside width="200px" style="border-radius: 5px;">
    <Aside :onType="handleType" :types="types" :defaultTab="params.type" />
  </el-aside>
  <el-main style="border-radius: 5px;">
    <el-tabs type="card" v-model="tabName" @tab-click="handleTab">
      <el-tab-pane label="指标统计" name="target">
        <el-form label-width="100px">
          <DateAnsys :start="params.startAfter" :end="params.startBefore" :onDatePicker="handleDatePicker">
          </DateAnsys>
          <Target :items="targets" isAll3 :value="mapParams.targetType" @onTarget="handerTarget" />
        </el-form>
        <div id="target" style="height: 400px; width: 100%;" v-loading="loading" />
      </el-tab-pane>
      <el-tab-pane label="历史统计" name="history">
        <el-form label-width="100px">
          <DateAnsys :start="params.startAfter" :end="params.startBefore" :onDatePicker="handleDatePicker">
            <div style="width: 120px; padding-left: 10px;">
              <SelectProc :value="params.procKey" :list="procs" @onSelect="handerSelect" />
            </div>
          </DateAnsys>
          <Target :items="targets" :value="mapParams.targetType" @onTarget="handerTarget" />
        </el-form>
        <div id="history" style="height: 400px; width: 100%;" v-loading="loading" />
      </el-tab-pane>
    </el-tabs>

    <ListTable
      style="padding-left: 20px;padding-right: 20px;"
      height="650"
      :loading="loading"
      :listData="listData"
      :onView="handleView"
      :onProc="handleProc"
      isProc
      :onSize="handleSizeChange"
      :onCurrent="handleCurrentChange"
      :page="page"
      optWidth="108">
      <el-table-column prop="procName" label="流程名称" />
      <el-table-column prop="allProc" label="申请次数" width="80" />
      <el-table-column prop="successPass" label="通过" width="80">
        <template slot-scope="scope">
          <el-button
            @click="handleOpen(scope.row, 'successPass')"
            type="text"
            size="small">
            {{ scope.row.successPass }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="failedPass" label="不通过" width="80">
        <template slot-scope="scope">
          <el-button
            @click="handleOpen(scope.row, 'failedPass')"
            type="text"
            size="small">
            {{ scope.row.failedPass }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="termination" label="终止" width="80">
        <template slot-scope="scope">
          <el-button
            @click="handleOpen(scope.row, 'termination')"
            type="text"
            size="small">
            {{ scope.row.termination }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="toDo" label="待办" width="80">
        <template slot-scope="scope">
          <el-button
            @click="handleOpen(scope.row, 'toDo')"
            type="text"
            size="small">
            {{ scope.row.toDo }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="keepRate" label="积压率%" width="80" />
      <el-table-column prop="avgDuration" label="平均办结(秒)" width="110">
        <template slot-scope="scope">
          {{ parseInt(scope.row.avgDuration/1000) }}
        </template>
      </el-table-column>
    </ListTable>
  </el-main>
</el-container>
</template>

<script>
import { types, targets } from './constants'
import { apiQuery, apiTargetList, apiHisChange, apiTabAuth } from './api'
import Aside from './aside'
import Target from './target'
import ListTable from './listTable'
import SelectProc from './selectProc'
import { formatDays } from './dateGroup'
import DateAnsys from './dateAnsys'
import { xyDatas, setMap, setMap2, setMapHistory, getSeries, getYName, getMap2Series, getProcs } from './map'
import { getBlankUrl } from './utils'
import vueConfig from '../../../../../vue.config.js'

export default {
  components: {
    Aside,
    Target,
    ListTable,
    SelectProc,
    DateAnsys
  },
  data() {
    return {
      loading: true,
      tabName: 'target',
      procs: [],
      types,
      targets,
      mapData: [],
      mapHISData: {},
      listData: [],
      params: {
        type: '',
        procKey: '',
        startAfter: formatDays(7),
        startBefore: formatDays(0)
      },
      mapParams: {
        targetType: targets[0].key
      },
      page: {
        pageSize: 15,
        pageSizes: [15, 25, 35, 45],
        currentPage: 1,
        total: 0
      }
    }
  },
  computed: {
    paramsWatch: function() {
      const {
        type,
        procKey,
        startAfter,
        startBefore
      } = this.params
      return {
        type,
        procKey,
        startAfter,
        startBefore
      }
    },
    mapWatch: function() {
      return {
        targetType: this.mapParams.targetType
      }
    },
    pageWatch: function() {
      const {
        pageSize,
        currentPage
      } = this.page
      return {
        pageSize,
        currentPage
      }
    }
  },
  watch: {
    paramsWatch: {
      handler(val, oldVal) {
        if (val && oldVal) {
          this.apiListQuery()
          if (this.tabName === 'target') {
            this.apiMapTarget()
          } else {
            this.apiMapHistory()
          }
        }
      },
      immediate: true
    },
    pageWatch: {
      handler(val, oldVal) {
        if (val && oldVal) { this.apiListQuery() }
      },
      immediate: true
    },
    tabName(val) {
      if (val === 'target') {
        this.apiMapTarget()
      } else {
        this.apiMapHistory()
      }
    },
    mapWatch: {
      handler(val) {
        if (this.tabName === 'target') {
          this.apiMapTarget()
        } else {
          this.apiMapHistory()
        }
      }
    },
    mapData(val) {
      const { targetType } = this.mapParams
      const yName = getYName(targets, targetType)
      const xDatas = xyDatas(val, 'procName')

      if (targetType === 'all3') {
        const series = getMap2Series(val)
        setMap2({
          id: 'target',
          yName,
          xDatas,
          series
        })
      } else {
        const yDatas = xyDatas(val, targetType)
        setMap({
          id: 'target',
          yName,
          xDatas,
          yDatas,
          title: '流程指标统计'
        })
      }
    },
    mapHISData(val) {
      const currentTarget = this.mapParams.targetType
      const yName = getYName(targets, currentTarget)
      const {
        startDateGroupList,
        procAnalysisHisChangeList,
        procList
      } = val

      const series = getSeries({
        procAnalysisHisChangeList,
        startDateGroupList,
        targetType: currentTarget === 'keepRate' ? 'keepRateDouble' : currentTarget
      })

      setMapHistory({
        id: 'history',
        xDatas: startDateGroupList,
        yName,
        series
      })
      this.procs = getProcs(procList)
    }
  },
  methods: {
    handleTab(tab, event) {
      this.tabName = tab.name
    },
    handleOpen(row, target) {
      const {
        procKey
      } = row
      const { type, startAfter, startBefore } = this.params
      const url = getBlankUrl(type, {
        procKey,
        startAfter,
        startBefore
      })
      let tab = target === 'toDo' ? 'JXZ' : 'YWC'
      window.open(`${url}&tab=${tab}&target=${target}`)
    },
    handleView(row) {
      const {
        procKey
      } = row
      const { type, startAfter, startBefore } = this.params
      const url = getBlankUrl(type, {
        procKey,
        startAfter,
        startBefore
      })
      window.open(url)
    },
    handleProc(row) {
      const {
        procKey,
        procName
      } = row
      const { type, startAfter, startBefore } = this.params
      window.open(`${vueConfig.publicPath}/#/workflow/taskAnalysis/${type}/${procKey}?procName=${procName}&start=${startAfter}&end=${startBefore}`)
    },
    handleType(key, keyPath) {
      this.params.type = key
    },
    handerSelect(val) {
      this.params.procKey = val
    },
    handerTarget(val) {
      this.mapParams.targetType = val
    },
    handleDatePicker(val) {
      this.params.startAfter = val[0]
      this.params.startBefore = val[1]
    },
    apiListQuery: async function() {
      this.loading = true
      const postdata = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        ...this.params
      }
      const { code, data } = await apiQuery(postdata)
      if (code === 200) {
        this.loading = false
        this.listData = data.records
        this.page.total = data.total
      }
    },
    apiMapTarget: async function() {
      this.loading = true
      let {
        targetType
      } = this.mapParams

      const postdata = {
        ...this.params,
        targetType: targetType === 'all3' ? 'allProc' : targetType
      }
      const { code, data } = await apiTargetList(postdata)
      if (code === 200) {
        this.loading = false
        this.mapData = data
      }
    },
    apiMapHistory: async function() {
      this.loading = true
      const postdata = {
        ...this.params,
        ...this.mapParams
      }
      const { code, data } = await apiHisChange(postdata)
      if (code === 200) {
        this.loading = false
        this.mapHISData = data
      }
    },
    initTabServe: async function() {
      const { code, data } = await apiTabAuth()
      if (code === 200) {
        const {
          all,
          departInvolved,
          departManage
        } = data
        if (all) {
          this.types[0].isShow = true
        }
        if (departInvolved) {
          this.types[1].isShow = true
        }
        if (departManage) {
          this.types[2].isShow = true
        }
      }
    },
    initTab: function() {
      const iTypes = this.types
      let currentTab
      for (let i = 0; i < iTypes.length; i++) {
        const {
          isShow
        } = iTypes[i]
        if (isShow) {
          currentTab = iTypes[i]
          break
        }
      }
      this.params.type = currentTab.key
    },
    initPage: async function() {
      await this.initTabServe()
      this.initTab()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
    }
  },
  created() {
    this.initPage()
  },
  activated() {
    this.apiListQuery()
  }
}
</script>

<style lang='scss' scoped>
.ResourceManageContainer{
  padding: 0 15px;
  height: 96%;
}
.el-aside {
  background-color: #FFF;
  margin-right: 15px;
}
.el-main {
  background-color: #FFF;
}
</style>
